var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanSize1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 874,
    height: 744,
    viewBox: "0 0 874 744",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M654.59 273.623C667.759 273.623 678.47 284.334 678.47 297.503C678.47 310.672 667.759 321.383 654.59 321.383C641.421 321.383 630.71 310.672 630.71 297.503C630.71 284.334 641.421 273.623 654.59 273.623Z",
    fill: "#E01454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M740.81 345.264C747.131 345.264 752.223 350.356 752.223 356.677C752.223 362.998 747.131 368.09 740.81 368.09C734.489 368.09 729.397 362.998 729.397 356.677C729.221 350.531 734.313 345.264 740.81 345.264Z",
    fill: "#4AADE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M845.461 264.85C855.82 264.85 864.424 273.278 864.424 283.813C864.424 294.173 855.996 302.777 845.461 302.777C834.925 302.777 826.497 294.348 826.497 283.813C826.497 273.278 834.925 264.85 845.461 264.85Z",
    fill: "#7DBA24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.023 174.767C166.811 254.836 206.67 268.707 261.98 321.384C307.633 364.93 293.937 463.259 284.28 523.486C244.772 502.591 190.515 473.619 182.438 435.516C176.82 409.178 178.575 395.131 169.972 370.373C153.642 465.19 196.134 495.04 270.935 542.098C313.076 568.612 306.228 575.636 335.551 604.256C352.935 621.288 362.768 624.8 367.86 627.785C368.913 630.243 370.318 632.526 372.249 634.458C372.601 640.954 369.616 654.475 366.279 688.714C365.05 701.006 367.157 716.106 371.723 733.138C385.067 734.894 398.412 736.299 411.757 737.528C403.153 717.335 398.061 702.41 398.236 695.211C398.588 676.599 409.825 625.854 409.298 618.128C411.757 345.615 656.527 434.638 758.017 302.42C782.599 270.463 808.06 264.493 838.261 246.759C837.383 244.652 838.085 246.407 838.436 248.163C843.177 247.988 843.353 241.842 834.398 241.842C762.055 241.667 723.777 326.651 673.91 337.362C638.441 344.912 542.219 352.463 499.375 378.099C499.2 365.808 496.566 352.638 490.771 337.889L483.924 322.788L484.626 322.437C475.32 306.634 490.069 360.54 474.442 399.169C429.842 428.141 375.059 509.439 369.44 593.545C337.658 575.284 348.545 565.978 323.787 547.015C323.963 546.312 324.314 545.434 324.489 544.732C332.918 476.253 345.384 376.694 300.258 316.116L296.922 311.902C292.708 306.81 287.967 301.893 282.875 297.504C231.603 253.255 190.34 241.491 167.513 171.958C157.154 140.352 139.244 96.9818 117.471 71.5215C117.822 87.1488 142.053 149.132 148.023 174.767Z",
    fill: "#1B335C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.978 727.352L405.958 726.123L460.566 743.857H303.063L366.978 727.352Z",
    fill: "#1B335C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.94 269.945C163.3 269.945 171.904 278.374 171.904 288.909C171.904 299.444 163.475 307.872 152.94 307.872C142.58 307.872 133.977 299.444 133.977 288.909C133.977 278.374 142.405 269.945 152.94 269.945Z",
    fill: "#E01454"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8179 190.395C19.8415 190.395 25.6359 196.189 25.6359 203.212C25.6359 210.236 19.8415 216.03 12.8179 216.03C5.79441 216.03 0 210.236 0 203.212C0 196.189 5.79441 190.395 12.8179 190.395Z",
    fill: "#7DBA24"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.979 134.033C353.636 134.033 361.538 141.935 361.538 151.592C361.538 161.249 353.636 169.151 343.979 169.151C334.321 169.151 326.42 161.249 326.42 151.592C326.42 141.935 334.321 134.033 343.979 134.033Z",
    fill: "#E8730F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.987 283.818C547.309 283.818 552.401 288.91 552.401 295.232C552.401 301.553 547.309 306.645 540.987 306.645C534.666 306.645 529.574 301.553 529.574 295.232C529.574 288.91 534.666 283.818 540.987 283.818Z",
    fill: "#4AADE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647.046 178.982C657.405 178.982 666.009 187.411 666.009 197.946C666.009 208.306 657.581 216.909 647.046 216.909C636.51 216.909 628.082 208.481 628.082 197.946C628.258 187.411 636.686 178.982 647.046 178.982Z",
    fill: "#7DBA24"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.716 378.625C689.358 378.625 699.718 388.809 699.718 401.627C699.718 414.269 689.534 424.629 676.716 424.629C664.074 424.629 653.714 414.445 653.714 401.627C653.714 388.985 664.074 378.625 676.716 378.625Z",
    fill: "#EDBA0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanSize1);
export default __webpack_public_path__ + "static/media/plan_size_1.73697031bccdb53836c6ffedf5257332.svg";
export { ForwardRef as ReactComponent };